<template>
  <div class="contact page">
    <h1>Contact</h1>
    <a class="nav-link" href="malito:dukgoapp@gmail.com">dukgoapp@gmail.com</a>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>

</style>